import React from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";

import { AuthProvider } from "./contexts/AuthContext";

import ProtectedRoute from "./components/ProtectedRoute";
import AccountLayout from "./components/layout/AccountLayout";
import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";

import Website from "./pages/Website";
import Despre from "./pages/Despre";
import Cookies from "./pages/Cookies";
import Consultanta from "./pages/Services/Consultanta";
import Programare from "./pages/Services/Programare";
import Montaj from "./pages/Services/Montaj";
import Cladiri from "./pages/Services/Cladiri";
import Automatizari from "./pages/Services/Automatizari";
import Modelhome from "./pages/Services/Modelhome";

import { BASE_FOLDER } from "./config";
import BlogPosts from "./pages/admin/BlogPosts";
import BlogEditor from "./pages/admin/BlogEditor";
import SiteSettings from "./pages/admin/SiteSettings";
import BlogPost from "./pages/BlogPost";
import Blog from "./pages/Blog";
import CookieConsent from "./components/CookieConsent";
import Confidentialitate from "./pages/Confidentialitate";

function App() {
  return (
    <AuthProvider>
      <div
        id="kt_docs_toast_stack_container"
        className="toast-container position-fixed bottom-0 end-0 p-3 z-index-9999"
      ></div>
      <BrowserRouter basename={"/" + BASE_FOLDER}>
        <Routes>
          {/* Public Routes */}
          {/* <Route path="/ai" element={<WebsiteAi />} /> */}
          <Route path="/account/login" element={<Login />} />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <AccountLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="site-settings" element={<SiteSettings />} />
            <Route path="blog-posts" element={<BlogPosts />} />
            <Route path="blog-posts/create" element={<BlogEditor />} />
            <Route path="blog-posts/edit/:id" element={<BlogEditor />} />
            {/* Add more admin routes here as needed */}
          </Route>
          <Route
            path="*"
            element={<Navigate to="/account/dashboard" replace />}
          />
        </Routes>
      </BrowserRouter>
      <BrowserRouter basename="/">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Website />} />
          <Route path="/despre-noi" element={<Despre />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/confidentialitate" element={<Confidentialitate />} />
          <Route
            path="/servicii/consultanta-si-proiectare"
            element={<Consultanta />}
          />
          <Route
            path="/servicii/programare-si-integrare"
            element={<Programare />}
          />
          <Route path="/servicii/montaj" element={<Montaj />} />
          <Route path="/servicii/cladiri-inteligente" element={<Cladiri />} />
          <Route path="/servicii/automatizari" element={<Automatizari />} />
          <Route path="/servicii/modelhome" element={<Modelhome />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </BrowserRouter>
      <CookieConsent />
    </AuthProvider>
  );
}

export default App;
